/**
 * 任务管理器
 *
 * 处理:
 * 1. 新问题取消旧任务
 * 2. 页面销毁释放资源
 */

export default class TaskManager {
    constructor() {
        this.taskId = 0;
    }

    /**
     * 创建新任务
     */
    create() {
        this.taskId++;
        return this.taskId;
    }

    /**
     * 获取当前任务
     */
    current() {
        return this.taskId;
    }

    /**
     * 判断任务是否有效
     */
    valid(id) {
        return id === this.taskId;
    }

    /**
     * 重置任务
     */
    reset() {
        this.taskId++;
    }

}